import { IoMdDownload } from "react-icons/io";
import React from 'react'
import Layout from '../../Layout'
import '../CSS/tekapick.css'
import TekaPickApp from '../../../assets/images/TekaPickApp.png';
import TekaLogo from '../../../assets/images/authentek_A_logo.png';
import tekaPickQr from '../../../assets/images/TEKaPickQR.png';
import Title from "../../Title";

const TEKaPickApp = () => {

    const handleApkDownload = () => {
        // URL to your APK file (could be hosted on a server)
        const apkUrl = 'https://authentekstorage.blob.core.windows.net/teka-software/TEKaPickApp.apk'; // Replace with actual URL
        const link = document.createElement('a');
        link.href = apkUrl;
        link.download = 'TEKaPickApp.apk'; // Filename for download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <div>
            <Title title="TEKaPick Andriod"></Title>

            <Layout>
                <section className='teka-pick-download py-5'>

                    <div className="download-btn">
                        <button onClick={handleApkDownload} className="btn btn-primary">
                            Download App <IoMdDownload />
                        </button>
                        <span>
                            <b>Update Available</b>
                            <p className="d-block">New software is ready to be installed.</p>
                        </span>
                    </div>

                    <div className='container'>
                        <h5 className='d-flex align-items-center gap-2 mb-3'><img src={TekaLogo} width={25} /> TEKaPick App</h5>
                        <div className='row row-gap-3 align-items-center'>
                            <div className='col-lg-3 d-none d-lg-block'>
                                <div className='image-box'>
                                    <img src={TekaPickApp} className='w-100' />
                                </div>
                            </div>
                            <div className='col-lg-9'>
                                <div className='content-box'>
                                    <h1>Download This App</h1>
                                    <h5>Welcome to TEKaPick Mobile App.</h5>
                                    <span>Scan QR code to download the .apk to your phone.</span>

                                    <div className='qr-code'>
                                        <img src={tekaPickQr} alt='QR Code' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        </div>
    )
}

export default TEKaPickApp